import React, { useState, useMemo, useEffect } from "react";
import { useMsal, useAccount } from "@azure/msal-react";
import {
	BrowserRouter as Router,
	Navigate,
	Routes,
	Route,
} from "react-router-dom";
import CONFIG from "../config";
import pkg from "../../package.json";

import {
	MsalProvider,
	AuthenticatedTemplate,
	UnauthenticatedTemplate,
	MsalAuthenticationTemplate,
} from "@azure/msal-react";
import { PublicClientApplication, InteractionType } from "@azure/msal-browser";
import { msalConfig } from "../config/authConfig";

import * as Utils from "../lib/utils";

import Home from "../routes/home";
import HR from "../routes/hr";
import Employee from "../routes/employee";
import AdminReports from "../routes/adminReports";
import EmployeeReports from "../routes/employeeReports";
import SalaryHistory from "../routes/salaryHistory";
import Budget from "../routes/budget";
import EmployeeList from "../routes/employeeList";
import Managers from "../routes/managers";
import Reviewers from "../routes/reviewers";
import Dashboard from "../routes/dashboard";
import Compensation from "../routes/compensation";
import Adjustments from "../routes/adjustments";
import SalaryGroups from "../routes/salaryGroups";
import SalaryGroupRanges from "../routes/salaryGroupRanges";
import SalaryDisplay from "../routes/salaryDisplay";
import JobTitleAlias from "../routes/jobTitleAlias";
import Support from "../routes/support";
import EmployeeMetrics from "../routes/employeeMetrics";

import { SignOutMenuItem } from "../components/signOutMenuItem";

import LogoImg from "../images/geo_logo.dcfac9cb-compressed.svg";

const pca = new PublicClientApplication(msalConfig);

const RouterScreen = () => {
	const { instance, accounts, inProgress } = useMsal();
	const account = useAccount(accounts[0] || {});

	// console.log("account", account);
	
	const [isOpen, setIsOpen] = useState(false);
	const [userAccount, setUserAccount] = useState(null);
	const [isUserAccountFetched, setIsUserAccountFetched] = useState(false);
	const [uncaughtErrorOccurred, setUncaughtErrorOccurred] = useState(false);
	const [errorDetails, setErrorDetails] = useState(null);

	window.onerror = (message, source, line, col, error) => {
		console.log("Global uncaught error:", error);
		// window.alert("An Error has occurred:" + error);
		setUncaughtErrorOccurred(true);
		setErrorDetails(error.toString());
		return true; // Prevents the default browser error handling
	};

	window.addEventListener("unhandledrejection", (event) => {
		console.log("Global unhandled promise rejection:", event.reason);
		// window.alert("An Error has occurred:" + event.reason);
		setUncaughtErrorOccurred(true);
		setErrorDetails(event.reason.toString());
		return false;
	});

	try{
		// console.log("account",account)

		const fetchData = async () => {
			try {
				// console.log("CONFIG.debug", CONFIG.debug);
				const isNotProd = CONFIG.debug || CONFIG.staging;
				const impUser = isNotProd
					? localStorage.getItem("impersonated_user")
					: "";
				const selectedUser = isNotProd && impUser ? impUser : account.username;

				if (account) {
					const jsonUserResponse = await Utils.getData(
						"/api/user/details?email=" + selectedUser,
						instance,
						account
					);
					setUserAccount(jsonUserResponse);
					setIsUserAccountFetched(true);

					const activeAdjustmentsResponse = await Utils.getData(
						"/api/compensation/employees?manager_hris_id=" + jsonUserResponse.employee_hris_id,
						instance,
						account,
					);

					// console.log(window.location)
					if (window.location.pathname == "" || window.location.pathname == "/") {
						if (
							jsonUserResponse &&
							jsonUserResponse.access_level &&
							(
								jsonUserResponse.access_level.indexOf("ADMIN") > -1 ||
								jsonUserResponse.access_level.indexOf("MODERATOR") > -1
							)
						) {
							window.location = "/hr";
						} else if(activeAdjustmentsResponse.length) {
							window.location = "/compensation?manager_hris_id=" + jsonUserResponse.employee_hris_id;
						} else{	
							window.location = "/dashboard";
						}
					}
				} else {
					console.log("Login not set.");
				}
			} catch (error) {
				console.error(error);
				return;
			}
		};

		useEffect(() => {
			fetchData();
		}, [account]);

		// console.log("userAccount", userAccount);

		const getNavMenu = () => {
			const menuClass = `dropdown-menu${isOpen ? " show" : ""}`;

			return (
				<div
					id="menu"
					className="dropdown col-sm-6"
					style={{ textAlign: "right" }}
					onClick={() => {
						setIsOpen(!isOpen);
					}}
				>
					<button
						className="btn btn-secondary dropdown-toggle"
						type="button"
						id="dropdownMenuButton1"
						data-bs-toggle="dropdown"
						aria-expanded="false"
						style={{ margin: "10px 20px 0px", left: "auto", right: "40px" }}
					>
						Menu
					</button>
					<ul
						id="menu-dropdown"
						className={menuClass}
						aria-labelledby="dropdownMenuButton1"
						style={{ left: "auto", right: "20px" }}
					>
						<li>
							<span
								style={{ marginLeft: "25px", borderBottom: "1px solid #DDD" }}
							>
								{`v${pkg.version}`}
							</span>
						</li>

						<li>
							<a className="dropdown-item" href="/dashboard">
								Dashboard
							</a>
						</li>

						{userAccount &&
						userAccount.access_level &&
						(
							userAccount.access_level.indexOf("ADMIN") > -1 ||
							userAccount.access_level.indexOf("MODERATOR") > -1
						) ? (
							<div>
								{/* <li><a className="dropdown-item" href="/home">Home</a></li> */}
								<li>
									<a className="dropdown-item" href="/employeeList">
										Employee List
									</a>
								</li>
								<li>
									<a className="dropdown-item" href="/managers">
										Managers
									</a>
								</li>
								<li>
									<a className="dropdown-item" href="/hr">
										HR
									</a>
								</li>
								<li>
									<a className="dropdown-item" href="/reviewers">
										Reviewers
									</a>
								</li>
								<li>
									<a className="dropdown-item" href="/budget">
										Budgets
									</a>
								</li>
								<li>
									<a className="dropdown-item" href="/adminReports">
										Admin Reports
									</a>
								</li>
								<li>
									<a className="dropdown-item" href="/salaryGroups">
										Salary Management
									</a>
								</li>
								<li>
									<a className="dropdown-item" href="/employeeMetrics">
										Employee Metrics
									</a>
								</li>
							</div>
						) : null}
						<li>
							<a className="dropdown-item" href="/salaryDisplay">
								Salary Ranges
							</a>
						</li>
						<li>
							<a className="dropdown-item" href="/employeeReports">
								Employee Reports
							</a>
						</li>
						<li>
							<a
								className="dropdown-item"
								target="_BLANK"
								href="GeoEngineers%20Inc.%20Employee%20Compensation%20System%20(ECS)%20-%20Managers%20Instruction%20Guide.pdf"
							>
								ECS Manager Instructions
							</a>
						</li>
						<li>
							<a className="dropdown-item" href="/support">
								Support
							</a>
						</li>
						<SignOutMenuItem />
					</ul>
				</div>
			);
		};

		const onCompSystemAuthorized = (onAuthorized, onUnauthorized) => {
			if (
				userAccount &&
				userAccount.access_level &&
				(
					userAccount.access_level.indexOf("ADMIN") > -1 || 
					userAccount.access_level.indexOf("MODERATOR") > -1
				)
			) {
				return onAuthorized;
			} else {
				return onUnauthorized ? (
					onUnauthorized
				) : (
					<div>{isUserAccountFetched ? "Unauthorized" : ""}</div>
				);
			}
		};

		// Allows access to anyone in the user table (any access_level)
		// or any active employee who has direct reports (is a manager).
		const onSalaryDisplayAuthorized = (onAuthorized, onUnauthorized) => {
			// console.log("userAccount", userAccount);
			const isUserTableMember = userAccount && userAccount.access_level;
			const isManager = userAccount && userAccount.permitted_hris_users && userAccount.permitted_hris_users.length > 0;
			if (isUserTableMember || isManager) {
				return onAuthorized;
			} else {
				return onUnauthorized ? (
					onUnauthorized
				) : (
					<div>{isUserAccountFetched ? "Unauthorized" : ""}</div>
				);
			}
		};

		const isUserAdmin =
			userAccount &&
			userAccount.access_level &&
			(
				userAccount.access_level.indexOf("ADMIN") > -1 || 
				userAccount.access_level.indexOf("MODERATOR") > -1
			);
		// const userHasAdjustment = userAccount && userAccount.adjustment_uuid;
		// console.log("ERROR STATE", uncaughtErrorOccurred);

		const renderErrorBlock = (errorDetails)=>{
			console.log("CALLING RENDER ERROR BLOCK")
			return <div className="error-backdrop">
				<div className="global-error-block">
					<div className="error-header">
						<strong>An error has occurred while performing this operation.  Please refresh the page to continue.</strong> <br />
						If this problem persists, please contact <a href="mailto://softwareengineringsupport@geoengineers.com">softwareengineringsupport@geoengineers.com</a>.
					</div>
					<div className="error-description">
						<strong>Error Details:</strong><br /> 
						{errorDetails}<br /><br />
						Error timestamp: {(new Date()).toLocaleString()}<br />
						Error URL: {window.location.href}
					</div>
				</div>
			</div>;
		}

		return (
			<div>
				{uncaughtErrorOccurred ? renderErrorBlock(errorDetails) : null}
				<Router>
					<div className="headerBar">
						<div
							className="row main-header"
							style={{ width: "100%", margin: "0", position: "absolute" }}
						>
							<div
								id="geo-logo"
								className="col-sm-6"
								style={{
									cursor: "pointer",
								}}
							>
								<a href="/" className="navbarLink">
									<img
										src={LogoImg}
										style={{ width: "150px", margin: "0px 0px 5px 0px" }}
										alt={"GeoEngineers Logo"}
									/>
									&nbsp;
									<span style={{ fontSize: "14pt" }}>
										Employee Compensation System (ECS)
									</span>
								</a>
							</div>

							<MsalAuthenticationTemplate>
								{getNavMenu()}
							</MsalAuthenticationTemplate>
						</div>
					</div>

					{/* A <Switch> looks through its children <Route>s and
				renders the first one that matches the current URL. */}
					<div
						style={{
							position: "absolute",
							top: "60px",
							width: "100%",
						}}
					>
						<Routes>
							<Route
								exact
								path="/home"
								element={
									<div>
										<MsalAuthenticationTemplate
											interactionType={InteractionType.Redirect}
										>
											<Home />
										</MsalAuthenticationTemplate>
										<UnauthenticatedTemplate>
											<span>
												You are not currently authenticated, please login to
												continue.
											</span>
										</UnauthenticatedTemplate>
									</div>
								}
							/>

							<Route
								exact
								path="/employeeList"
								element={
									<div>
										<MsalAuthenticationTemplate
											interactionType={InteractionType.Redirect}
										>
											{onCompSystemAuthorized(<EmployeeList />)}
										</MsalAuthenticationTemplate>
										<UnauthenticatedTemplate>
											<span>
												You are not currently authenticated, please login to
												continue.
											</span>
										</UnauthenticatedTemplate>
									</div>
								}
							/>

							<Route
								exact
								path="/employee"
								element={
									<div>
										<MsalAuthenticationTemplate
											interactionType={InteractionType.Redirect}
										>
											<Employee userAccount={userAccount} />
										</MsalAuthenticationTemplate>
										<UnauthenticatedTemplate>
											<span>
												You are not currently authenticated, please login to
												continue.
											</span>
										</UnauthenticatedTemplate>
									</div>
								}
							/>

							<Route
								exact
								path="/managers"
								element={
									<div>
										<MsalAuthenticationTemplate
											interactionType={InteractionType.Redirect}
										>
											{onCompSystemAuthorized(<Managers />)}
										</MsalAuthenticationTemplate>
										<UnauthenticatedTemplate>
											<span>
												You are not currently authenticated, please login to
												continue.
											</span>
										</UnauthenticatedTemplate>
									</div>
								}
							/>

							<Route
								exact
								path="/reviewers"
								element={
									<div>
										<MsalAuthenticationTemplate
											interactionType={InteractionType.Redirect}
										>
											{onCompSystemAuthorized(<Reviewers />)}
										</MsalAuthenticationTemplate>
										<UnauthenticatedTemplate>
											<span>
												You are not currently authenticated, please login to
												continue.
											</span>
										</UnauthenticatedTemplate>
									</div>
								}
							/>

							<Route
								exact
								path="/dashboard"
								element={
									<div>
										<MsalAuthenticationTemplate
											interactionType={InteractionType.Redirect}
										>
											<Dashboard userAccount={userAccount} />
										</MsalAuthenticationTemplate>
										<UnauthenticatedTemplate>
											<span>
												You are not currently authenticated, please login to
												continue.
											</span>
										</UnauthenticatedTemplate>
									</div>
								}
							/>

							<Route
								exact
								path="/compensation"
								element={
									<div>
										<MsalAuthenticationTemplate
											interactionType={InteractionType.Redirect}
										>
											<Compensation userAccount={userAccount} />
										</MsalAuthenticationTemplate>
										<UnauthenticatedTemplate>
											<span>
												You are not currently authenticated, please login to
												continue.
											</span>
										</UnauthenticatedTemplate>
									</div>
								}
							/>

							<Route
								exact
								path="/salaryHistory"
								element={
									<div>
										<MsalAuthenticationTemplate
											interactionType={InteractionType.Redirect}
										>
											{onCompSystemAuthorized(<SalaryHistory />)}
										</MsalAuthenticationTemplate>
										<UnauthenticatedTemplate>
											<span>
												You are not currently authenticated, please login to
												continue.
											</span>
										</UnauthenticatedTemplate>
									</div>
								}
							/>

							<Route
								exact
								path="/hr"
								element={
									<div>
										<MsalAuthenticationTemplate
											interactionType={InteractionType.Redirect}
										>
											{onCompSystemAuthorized(<HR userAccount={userAccount} />)}
										</MsalAuthenticationTemplate>
										<UnauthenticatedTemplate>
											<span>
												You are not currently authenticated, please login to
												continue.
											</span>
										</UnauthenticatedTemplate>
									</div>
								}
							/>

							<Route
								exact
								path="/adjustments"
								element={
									<div>
										<MsalAuthenticationTemplate
											interactionType={InteractionType.Redirect}
										>
											{onCompSystemAuthorized(<Adjustments />)}
										</MsalAuthenticationTemplate>
										<UnauthenticatedTemplate>
											<span>
												You are not currently authenticated, please login to
												continue.
											</span>
										</UnauthenticatedTemplate>
									</div>
								}
							/>

							<Route
								exact
								path="/budget"
								element={
									<div>
										<MsalAuthenticationTemplate
											interactionType={InteractionType.Redirect}
										>
											{onCompSystemAuthorized(<Budget />)}
										</MsalAuthenticationTemplate>
										<UnauthenticatedTemplate>
											<span>
												You are not currently authenticated, please login to
												continue.
											</span>
										</UnauthenticatedTemplate>
									</div>
								}
							/>

							<Route
								exact
								path="/adminReports"
								element={
									<div>
										<MsalAuthenticationTemplate
											interactionType={InteractionType.Redirect}
										>
											{onCompSystemAuthorized(<AdminReports />)}
										</MsalAuthenticationTemplate>
										<UnauthenticatedTemplate>
											<span>
												You are not currently authenticated, please login to
												continue.
											</span>
										</UnauthenticatedTemplate>
									</div>
								}
							/>

							<Route
								exact
								path="/employeeReports"
								element={
									<div>
										<MsalAuthenticationTemplate
											interactionType={InteractionType.Redirect}
										>
											<EmployeeReports userAccount={userAccount} />
										</MsalAuthenticationTemplate>
										<UnauthenticatedTemplate>
											<span>
												You are not currently authenticated, please login to
												continue.
											</span>
										</UnauthenticatedTemplate>
									</div>
								}
							/>

							<Route
								exact
								path="/salaryGroups"
								element={
									<div>
										<MsalAuthenticationTemplate
											interactionType={InteractionType.Redirect}
										>
											{onCompSystemAuthorized(<SalaryGroups />)}
										</MsalAuthenticationTemplate>
										<UnauthenticatedTemplate>
											<span>
												You are not currently authenticated, please login to
												continue.
											</span>
										</UnauthenticatedTemplate>
									</div>
								}
							/>

							<Route
								exact
								path="/salaryGroupRanges"
								element={
									<div>
										<MsalAuthenticationTemplate
											interactionType={InteractionType.Redirect}
										>
											{onCompSystemAuthorized(<SalaryGroupRanges />)}
										</MsalAuthenticationTemplate>
										<UnauthenticatedTemplate>
											<span>
												You are not currently authenticated, please login to
												continue.
											</span>
										</UnauthenticatedTemplate>
									</div>
								}
							/>

							<Route
								exact
								path="/jobTitleAlias"
								element={
									<div>
										<MsalAuthenticationTemplate
											interactionType={InteractionType.Redirect}
										>
											{onCompSystemAuthorized(<JobTitleAlias />)}
										</MsalAuthenticationTemplate>
										<UnauthenticatedTemplate>
											<span>
												You are not currently authenticated, please login to
												continue.
											</span>
										</UnauthenticatedTemplate>
									</div>
								}
							/>

							<Route
								exact
								path="/employeeMetrics"
								element={
									<div>
										<MsalAuthenticationTemplate
											interactionType={InteractionType.Redirect}
										>
											{onCompSystemAuthorized(<EmployeeMetrics userAccount={userAccount} />)}
										</MsalAuthenticationTemplate>
										<UnauthenticatedTemplate>
											<span>
												You are not currently authenticated, please login to
												continue.
											</span>
										</UnauthenticatedTemplate>
									</div>
								}
							/>

							<Route
								exact
								path="/salaryDisplay"
								element={
									<div>
										<MsalAuthenticationTemplate
											interactionType={InteractionType.Redirect}
										>
											{onSalaryDisplayAuthorized(<SalaryDisplay userAccount={userAccount} />)}
										</MsalAuthenticationTemplate>
										<UnauthenticatedTemplate>
											<span>
												You are not currently authenticated, please login to
												continue.
											</span>
										</UnauthenticatedTemplate>
									</div>
								}
							/>

							<Route
								exact
								path="/support"
								element={
									<div>
										<MsalAuthenticationTemplate
											interactionType={InteractionType.Redirect}
										>
											<Support />
										</MsalAuthenticationTemplate>
										<UnauthenticatedTemplate>
											<span>
												You are not currently authenticated, please login to
												continue.
											</span>
										</UnauthenticatedTemplate>
									</div>
								}
							/>

							<Route
								path="*"
								element={
									<div>
										<MsalAuthenticationTemplate
											interactionType={InteractionType.Redirect}
										>
											{!userAccount ? <Home /> : !isUserAdmin ? <div></div> : null}
										</MsalAuthenticationTemplate>
										<UnauthenticatedTemplate>
											<span>
												You are not currently authenticated, please login to
												continue.
											</span>
										</UnauthenticatedTemplate>
									</div>
								}
							/>
						</Routes>
					</div>

					<div id="footer" className="container-fluid">
						GeoEngineers 2021
					</div>
				</Router>
			</div>
		);
	}catch(e){
		console.log("There is an error", e);
		return <div>An error has occurred rendering this page.  Sending information to software support.</div>
	}
};

export default RouterScreen;
